import React from "react";
import { PageHeading } from "../../components/ui/PageHeading";

const User = () => (
  <div className="px-3 sm:px-5">
    <PageHeading title="User" />
  </div>
);

export default User;
